import { formatCameraLabel } from "@src/utils/key-parser";

export function normalizeCameraNickname(nickname: string | null | undefined): string | null {
  const trimmed = nickname?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : null;
}

export function resolveCameraDisplayName(cameraKey: string, nickname: string | null | undefined): string {
  return normalizeCameraNickname(nickname) ?? formatCameraLabel(cameraKey);
}
